import { render, staticRenderFns } from "./gaokao.vue?vue&type=template&id=f6ed5cf0&scoped=true&"
import script from "./gaokao.vue?vue&type=script&lang=js&"
export * from "./gaokao.vue?vue&type=script&lang=js&"
import style0 from "./gaokao.vue?vue&type=style&index=0&id=f6ed5cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ed5cf0",
  null
  
)

export default component.exports